import TagManager from 'react-gtm-module';

import { getEnv } from '../config';

export const initTagManager = (dataLayer: Record<string, string>): void => {
    const gtmId = getEnv('REACT_APP_GTM_KEY');

    if (gtmId) {
        TagManager.initialize({
            gtmId,
            dataLayer,
        });
    }
};

export const gtmEvent = (dataLayer: Record<string, string>): void => {
    TagManager.dataLayer({ dataLayer });
};
